import React, { useState } from "react";
import { useClientAuth } from "../../../context/ClientAuthContext";
import CommentService from "../../../services/comment";
import { showErrorToaster } from "../../../adminCompenents/listComponents/UI/toaster/error";
import { showSuccessToaster } from "../../../adminCompenents/listComponents/UI/toaster/success";
import "./index.scss";

const commentService = new CommentService();

const CommentForm = ({ productId, onCommentAdded }) => {
  const { currentClient } = useClientAuth();
  const [comment, setComment] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!comment.trim()) {
      showErrorToaster("Veuillez saisir un commentaire");
      return;
    }

    setIsLoading(true);
    try {
      const newComment = await commentService.createComment({
        comment: comment.trim(),
        productId: productId,
      });
      
      onCommentAdded(newComment);
      setComment("");
      showSuccessToaster("Commentaire ajouté avec succès");
    } catch (error) {
      showErrorToaster("Erreur lors de l'ajout du commentaire");
    } finally {
      setIsLoading(false);
    }
  };

  if (!currentClient) {
    return (
      <div className="comment-form-login-required">
        <p>Vous devez être connecté pour laisser un commentaire.</p>
        <button 
          className="btn-login"
          onClick={() => window.location.href = "/login-page"}
        >
          Se connecter
        </button>
      </div>
    );
  }

  return (
    <div className="comment-form">
      <h4>Laisser un commentaire</h4>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <textarea
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            placeholder="Partagez votre avis sur ce produit..."
            className="comment-textarea"
            rows="4"
            disabled={isLoading}
            maxLength="500"
          />
          <div className="character-count">
            {comment.length}/500 caractères
          </div>
        </div>
        <div className="form-actions">
          <button
            type="submit"
            className="btn-submit"
            disabled={isLoading || !comment.trim()}
          >
            {isLoading ? "Publication..." : "Publier le commentaire"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default CommentForm;
